export default __webpack_public_path__ + "static/media/step2.bd8d4663.jpg";